import React from 'react';
import { cn } from '../../lib/utils';
interface BookCallButtonProps {
  onClick: () => void;
  className?: string;
}
export const BookCallButton: React.FC<BookCallButtonProps> = ({
  onClick,
  className
}) => {
  return <button onClick={onClick} className={cn('py-3 px-8 text-white font-medium rounded-lg text-base sm:text-lg', 'bg-gradient-to-r from-[#2c3a80] to-[#1e2a66] hover:from-[#1e2a66] hover:to-[#0a1445]', 'transition-all duration-300 transform hover:scale-105 shadow-lg', className)} data-id="element-250">
      Book a Call
    </button>;
};